import React from "react";
import { motion } from "framer-motion";

const Hero = () => {
  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="hero" className="pt-20 dark-section relative">
      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Future-Proof Smart, Secure and Compliant{" "}
              <span className="bg-gradient-to-r from-blue-400 via-blue-500 to-purple-600 bg-clip-text text-transparent">IT Solutions</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
              Ramwin Technology is at the forefront of IT innovation, delivering cutting-edge products and services that empower businesses to thrive in a digital-first world.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <motion.a
                href="#contact"
                onClick={(e) => scrollToSection(e, 'contact')}
                className="inline-flex items-center gap-2 bg-transparent border-2 border-blue-500 hover:border-purple-500 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-blue-500/20 hover:shadow-purple-500/30"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Contact Us
                <span>→</span>
              </motion.a>
            </div>
          </motion.div>

          {/* Feature Pills */}
          <motion.div
            className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
          >
            <div className="dark-card rounded-lg p-6 relative z-10">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                <h3 className="text-lg font-bold text-white">Ramwin Technology</h3>
              </div>
              <p className="text-gray-400">Governance-First Products</p>
            </div>
            <div className="dark-card rounded-lg p-6 relative z-10">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                <h3 className="text-lg font-bold text-white">Powered by Innovation</h3>
              </div>
              <p className="text-gray-400">Enterprise-Ready Solutions</p>
            </div>
            <div className="dark-card rounded-lg p-6 relative z-10">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                <h3 className="text-lg font-bold text-white">Trusted by Industry Leaders</h3>
              </div>
              <p className="text-gray-400">Users Across All Industries</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
